import { render } from "./wokerDetail12.vue?vue&type=template&id=24af9e53&scoped=true"
import script from "./wokerDetail12.vue?vue&type=script&lang=js"
export * from "./wokerDetail12.vue?vue&type=script&lang=js"

import "./wokerDetail12.vue?vue&type=style&index=0&id=24af9e53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24af9e53"]])

export default __exports__